import { Fragment } from 'react';
import { Accordion, AccordionItem as Item} from '@szhsin/react-accordion';
import styles from './FrequentlyAskedQuestions.module.scss';
import chevronDown from './chevron-down.svg';
import thanksARamaGiveAway from './../../images/30k-thanks-a-rama-giveaway.png';
import foxLogosFaq from './../../images/fox-shows-faq.png';
import { createMarkup } from '../../utils/helpers';

const AccordionItem = ({ header, ...rest }) => (
    <Item
      {...rest}
      header={
        <>
          {header}
          <img className={styles.chevron} src={chevronDown} alt="Chevron Down" />
        </>
      }
      className={styles.item}
      buttonProps={{
        className: ({ isEnter }) =>
          `${styles.itemBtn} ${isEnter && styles.itemBtnExpanded}`,
      }}
      contentProps={{ className: styles.itemContent }}
      panelProps={{ className: styles.itemPanel }}
    />
  );

const questionAnswer = [
    {
        question : "How do I create an account?", 
        answer : "To set up your account, just enter your phone number on the websites’ login screen. You'll receive a one-time passcode via SMS—input the code, and your account will be created instantly."
    },
    {
        question : "What are digital tickets?", 
        answer : "Digital tickets are digital entries you earn by scanning QR codes across <strong>current season</strong> episodes of <i>25 Words or Less, Pictionary, & Person Place or Thing</i>. The more digital tickets you accumulate, the greater your chances of winning one of three grand prizes of <strong>$10,000!</strong>"
    },
    {
        question : "How do I start earning digital tickets?", 
        answer : "To earn digital tickets, simply watch <strong>current season</strong> episodes of <i>25 Words or Less, Pictionary, & Person Place or Thing</i>, look out for QR codes that appear on the screen across all three shows, and scan them with your mobile device. Each unique QR code scanned will earn you one digital ticket."
    },
    {
        question : "Do digital tickets expire?", 
        answer : "Tickets are only valid for the season in which they are issued. After the season concludes, the digital tickets will no longer be eligible for future drawings. The sweepstakes begin on 9/9/24 and conclude on 5/30/25."
    },
    {
        question : "How many digital tickets can be earned?", 
        answer : "You can earn one ticket per unique QR code scan during each <strong>current season</strong> episode of <i>25 Words or Less, Pictionary, & Person Place or Thing</i>. There are up to five scanning opportunities per episode."
    },
    {
        question : "Can I transfer my rewards to someone else?", 
        answer : "No, digital tickets are non-transferable. They are linked to your account and cannot be shared or transferred to others."
    },
    {
        question : "Help! My account is not working correctly", 
        answer : "If you’re having trouble accessing your account, first ensure that you’re entering the correct phone number and passcode on the log in page. If the issue persists, please reach out to our support team at <a href='mailto:digital@foxfirstrun.com'>digital@foxfirstrun.com</a> for further assistance."
    },
    {
        question : "How can I check how many digital tickets I have?", 
        answer : "To view your digital ticket balance, log in to the website and select the digital tickets icon in the top navigation bar. You’ll find a detailed breakdown of all the digital tickets you’ve accumulated."
    },
    {
        question : "My digital tickets aren't reflected accurately", 
        answer : "If your digital tickets are not showing up correctly on the website, please make sure that you’ve scanned the QR codes correctly during the episode. If the issue continues, contact us at <a href='mailto:digital@foxfirstrun.com'>digital@foxfirstrun.com</a>, and we’ll assist you."
    },
    {
        question : "Can my rewards be turned into something outside of the $10K?", 
        answer : "No, the digital tickets are solely used to enter the drawing for the $30K Thanks-A-Rama Giveaway."
    },
    {
        question : "Are there any referral bonuses for inviting friends to sign up?", 
        answer : "Currently, we do not offer any referral bonuses. However, we encourage you to share the website with friends so they can join in on the fun!"
    },
    {
        question : "Can I still play without creating an account? ", 
        answer : "Yes, you can participate in the at-home games without creating an account. However, creating an account makes it easier to track your progress and eliminates the need to enter your information each time you play."
    },
    {
        question : "What are the prizes I can win by earning digital tickets? ", 
        answer : "We will select three winners for the $30K Thanks-A-Rama-Giveaway who will each take home $10,000! "
    },    
]

const FrequentlyAskedQuestions = (props) => {
    const container = <div 
        style={{width: "94%", borderRadius: "20px", backgroundColor: "white", marginLeft: "auto", marginRight: "auto", color: "black", textAlign: "left", lineHeight: "150%", fontSize: "16px", fontFamily: "Inter", maxWidth: "480px"}}>

        <h2 style={{color: process.env.REACT_APP_NAME_FONT_COLOR, paddingTop: "20px", textAlign: "center"}}>Frequently Asked Questions</h2>
        <div className={styles.accordion}>
        {/* `transitionTimeout` prop should be equal to the transition duration in CSS */}
        <Accordion transition transitionTimeout={250}>
            {questionAnswer.map((item, index) => {
                return <AccordionItem header={item.question} initialEntered={index === 0}>
                    <div dangerouslySetInnerHTML={createMarkup(item.answer)}/>
                </AccordionItem>
            })}
        </Accordion>
        </div>
    </div>
    return (
        <Fragment>
            <div style={{textAlign: "center", paddingTop: "20px", maxWidth: "480px", marginLeft: "auto", marginRight: "auto"}}>
                <img src={thanksARamaGiveAway} alt="Thanks-A-Rama-Give-Away"/>
                <img src={foxLogosFaq} alt="Thanks-A-Rama-Give-Away Three logo shows" style={{width: "100%"}}/>
            </div>
            {container}
        </Fragment>        
    );
}

export default FrequentlyAskedQuestions;